import Account from './requests/Account';
import App from './requests/App';
import Auth from './requests/Auth';
import ChangeLog from './requests/ChangeLog';
import Country from './requests/Country';
import Cs from './requests/Cs';
import Currencies from './requests/Currencies';
import Currency from './requests/Currency';
import CurrencyRate from './requests/CurrencyRate';
import DataExport from './requests/DataExport';
import Delivery from './requests/Delivery';
import Dictionary from './requests/Dictionary';
import Document from './requests/Document';
import DocumentRegistry from './requests/DocumentRegistry';
import EntityInfo from './requests/EntityInfo';
import Event from './requests/Event';
import Export from './requests/Export';
import Integration from './requests/Integration';
import Invoice from './requests/Invoice';
import Kafka from './requests/Kafka';
import Language from './requests/Language';
import Leaderboard from './requests/Leaderboard';
import Localization from './requests/Localization';
import Metabase from './requests/Metabase';
import Nrm2 from './requests/Nrm2';
import Otp from './requests/Otp';
import PaymentSystem from './requests/PaymentSystem';
import Payout from './requests/Payout';
import Period from './requests/Period';
import Plan from './requests/Plan';
import PlanParameter from './requests/PlanParameter';
import PlanProperty from './requests/PlanProperty';
import PlatformSetting from './requests/PlatformSetting';
import Pos from './requests/Pos';
import ProfileField from './requests/ProfileField';
import TransactionLog from './requests/TransactionLog';
import Tree from './requests/Tree';
import WalletBalance from './requests/WalletBalance';
import WalletOperation from './requests/WalletOperation';
import WalletOperationType from './requests/WalletOperationType';
import WalletType from './requests/WalletType';
import V2 from './requests/V2';
import PaymentRule from './requests/PaymentRule';
import FieldType from './requests/FieldType';
import Cs2App from './cs2/App';
import Cs2Channel from './cs2/Channel';
import Cs2Event from './cs2/Event';
import Cs2EventType from './cs2/EventType';
import Cs2EventFilter from './cs2/EventFilter';
import Cs2Transport from './cs2/Transport';
import Cs2TransportClass from './cs2/TransportClass';
import Cs2Verificator from './cs2/Verificator';
import Cs2VerificatorClass from './cs2/VerificatorClass';
import Cs2Verification from './cs2/Verification';
import ActivityLog from './requests/ActivityLog';
import AclRole from './requests/AclRole';
import Admin from './requests/Admin';
import WalletTransferRule from './requests/WalletTransferRule';


export default function useRequest() {
  return {
    account: Account(),
    app: App(),
    auth: Auth(),
    changeLog: ChangeLog(),
    country: Country(),
    cs: Cs(),
    currencies: Currencies(),
    currency: Currency(),
    currencyRate: CurrencyRate(),
    dataExport: DataExport(),
    delivery: Delivery(),
    dictionary: Dictionary(),
    document: Document(),
    documentRegistry: DocumentRegistry(),
    entityInfo: EntityInfo(),
    event: Event(),
    export: Export(),
    integration: Integration(),
    invoice: Invoice(),
    kafka: Kafka(),
    language: Language(),
    leaderboard: Leaderboard(),
    localization: Localization(),
    metabase: Metabase(),
    nrm2: Nrm2(),
    otp: Otp(),
    paymentSystem: PaymentSystem(),
    payout: Payout(),
    period: Period(),
    plan: Plan(),
    planParameter: PlanParameter(),
    planProperty: PlanProperty(),
    platformSetting: PlatformSetting(),
    pos: Pos(),
    profileField: ProfileField(),
    transactionLog: TransactionLog(),
    tree: Tree(),
    walletBalance: WalletBalance(),
    walletOperation: WalletOperation(),
    walletOperationType: WalletOperationType(),
    walletType: WalletType(),
    v2: V2(),
    paymentRule: PaymentRule(),
    fieldType: FieldType(),
    cs2App: Cs2App(),
    cs2Channel: Cs2Channel(),
    cs2Event: Cs2Event(),
    cs2EventType: Cs2EventType(),
    cs2EventFilter: Cs2EventFilter(),
    cs2Transport: Cs2Transport(),
    cs2TransportClass: Cs2TransportClass(),
    cs2Verificator: Cs2Verificator(),
    cs2VerificatorClass: Cs2VerificatorClass(),
    cs2Verification: Cs2Verification(),
    activityLog: ActivityLog(),
    aclRole: AclRole(),
    admin: Admin(),
    walletTransferRule: WalletTransferRule(),
  };
}
